
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20bright%20living%20room%20interior%20with%20yellow%20Master%20DH62%20industrial%20dehumidifier%20machine%20placed%20in%20center%20of%20room%20near%20potted%20plant%2C%20contemporary%20furniture%2C%20wooden%20floor%2C%20large%20windows%20with%20natural%20light%2C%20residential%20space%20during%20water%20damage%20restoration%2C%20professional%20construction%20equipment%20in%20home%20setting%2C%20realistic%20photography%2C%20wide%20angle%20view%20showing%20full%20room&width=1920&height=1080&seq=hero-salon-osuszacz-master-dh62-v2&orientation=landscape"
          alt="Salon z osuszaczem budowlanym Master DH62 - profesjonalne osuszanie po zalaniu"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          <div className="flex-1 text-white">
            <p className="text-blue-400 text-sm font-semibold uppercase tracking-wider mb-4">
              Profesjonalne osuszanie i remonty
            </p>
            <h1 className="text-5xl lg:text-7xl font-bold leading-tight mb-6">
              Ratujemy Twoje<br />
              Wnętrza Po<br />
              Zalaniu
            </h1>
            <p className="text-lg lg:text-xl text-gray-200 mb-8 max-w-2xl leading-relaxed">
              Specjalizujemy się w profesjonalnym osuszaniu pomieszczeń, lokalizacji wycieków oraz
              kompleksowych remontach. Działamy 24/7, aby szybko przywrócić Twój dom do pełnej sprawności.
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={scrollToContact}
                className="px-8 py-4 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Bezpłatna Wycena
              </button>
              <a
                href="tel:+48691284309"
                className="px-8 py-4 border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Zadzwoń Teraz
              </a>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-20">
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 text-center border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">10+</div>
            <div className="text-sm text-gray-200">Lat Doświadczenia</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 text-center border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">100+</div>
            <div className="text-sm text-gray-200">Zrealizowanych Projektów</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 text-center border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">24/7</div>
            <div className="text-sm text-gray-200">Interwencja Awaryjna</div>
          </div>
        </div>
      </div>
    </section>
  );
}
